import BaseService from './BaseService'

const ApiService = {
    fetchData(param) {
        return new Promise((resolve, reject) => {
            debugger
            BaseService(param).then(response => {
                debugger
                resolve(response)
            }).catch(errors => {
                debugger
                reject(errors)
            })
        })
    }
}

export default ApiService